const convert = require('color-convert');
function convertColorByRule(color) {
  color = handleHex(color);
  let input = [
    color.match(/(.*?)a*\(/)
      ? getColorType(color.match(/(.*?)a*\(/)[1])
      : 'keyword',
    color.match(/\((.*?)\)/)
      ? color
          .match(/\((.*?)\)/)[1]
          .split(',')
          .slice(0, 3)
          .map((_) => _.replace('%', ''))
      : color,
    color.match(/\((.*?)\)/)
      ? color
          .match(/\((.*?)\)/)[1]
          .split(',')
          .slice(3, 4)
          .join('') || 1
      : 1,
  ];
  const [rgb, alpha] = [
    input[0] == 'rgb' ? input[1] : convert[input[0]].rgb(input[1]),
    input[2],
  ];
  return `rgba(${getDarkModeColor(rgb.map((_) => Number(_)).join(','))},${alpha})`;
}

function getColorType(type) {
  switch (type) {
    case 'hsb':
      return 'hsv';
    default:
      return type;
  }
}

function handleHex(color) {
  let hex = color.match(/(\#.*)[,]|(\#.*)/);
  if (hex) {
    hex = hex[1] || hex[2];
    let [_color, alpha] =
      hex.length < 7 ? [hex.slice(1), 1] : [hex.slice(1, 7), hex.slice(7, -1)];
    alpha = alpha && alpha != 1 ? (alpha[0] * 16 + alpha[1]) / 255 : 1;
    _color = convert.hex.rgb(_color);
    return color.includes('(')
      ? color.replace(hex, _color)
      : `rgba(${_color},${alpha})`;
  } else {
    return color;
  }
}

function getDarkModeColor(color) {
  switch (color) {
    case '20,25,30':
      return '196, 200, 204';
    case '255,255,255':
      return '17, 17, 17';
    case '100,105,110':
      return '145, 149, 154';
    case '140,145,150':
      return '105, 110, 114';
    case '200,205,210':
      return '48, 49, 51';
    case '0,75,150':
      return '102, 179, 255';
    case '2,25,48':
      return '35, 76, 117';
    case '250,60,75':
      return '250, 60, 75';
    case '0,110,244':
      return '0, 110, 244';
    case '50,184,70':
      return '50, 184, 70';
    case '246,112,16':
      return '246, 112, 16';
    case '8,108,240':
      return '8, 108, 240';
    case '0,113,206':
      return '0, 113, 206';
    case '14,134,203':
      return '14, 134, 203';
    case '129,188,13':
      return '129, 188, 13';
    case '15,124,16':
      return '15, 124, 16';
    case '245,107,44':
      return '245, 107, 44';
    case '231,0,18':
      return '231, 0, 18';
    case '246,157,53':
      return '246, 157, 53';
    case '50,184,70':
      return '50, 184, 70';
    case '0,144,21':
      return '0, 144, 21';
    case '246,157,53':
      return '246, 157, 53';
    case '235,164,23':
      return '235,164,23'; // #EBA417、DOTA2黄
    case '146,165,37':
      return '146,165,37'; // #92A525、DOTA2天辉绿
    case '194,60,42':
      return '194,60,42'; // #C23C2A、DOTA2夜魇红
    default: {
      return color
        .split(',')
        .map((_) => 255 - Number(_))
        .join(',');
    }
  }
}

// function test () {
//   convertColorByRule('hsba(26, 50%, 40%, 1)')
// }

// test()

exports.convertColorByRule = convertColorByRule;
